import codetria from "./apiConstants.codetria.js";
import dev from "./apiConstants.dev.js";
import stag from "./apiConstants.stag.js";
import prod from "./apiConstants.prod.js";

// Cambiar ambiente de las APIs
export default prod; // codetria, dev, stag, prod
